export interface AdminConfig {
    secretKey: string;
  }
  
  const adminConfig: AdminConfig = {
    secretKey: "admin@cb"
  };
  
  export default adminConfig;